import { ToastStateHandler, UserApi } from '../../../api';
import { TopicScoreDto } from '../../../commonTypes/user.types';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPatchTopicScore = () => {
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('evaluations');

    const exec = (topicId: string, evaluationId: string, body: TopicScoreDto): Promise<void> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.updateTopicScore({
                params: { topicId, evaluationId },
                body,
                onSuccess: () => {
                    // toastHandler.push('success', t('updateTopicScoreTitle'), t('updateTopicScoreSucceded'));
                    resolve();
                },
                onError: error => {
                    toastHandler.push('error', t('updateTopicScoreTitle'), t('updateTopicScoreFailed'));
                    reject(error);
                },
            });

            exec();
        });
    };

    return { exec };
};

export default useHttpPatchTopicScore;
